import React from 'react';
import _ from 'lodash';
import { Checkbox, FormControl, FormControlLabel } from '@mui/material';

export const BoolAllField = props => {
  const { field, formik } = props;
  const dependsOn = field.depends_on.trim().replaceAll('\n', '')
    .split(' ');

  React.useEffect(() => {
    const isFalse = dependsOn.some(name => formik.values[name] === false);

    if (isFalse) {
      formik.setFieldValue(field.name, false);
    } else {
      formik.setFieldValue(field.name, true);
    }

  }, dependsOn.map(value => formik.values[value]));

  return (
    <FormControl fullWidth style={{ paddingBottom: 8 }}>
      <FormControlLabel
        control={
          <Checkbox
            name={field.name}
            checked={formik.values[field.name] || false}
            onChange={(e, value) => {
              dependsOn.forEach(name => {
                formik.setFieldValue(name, value);
              });
            }}
          />
        }
        label={<span dangerouslySetInnerHTML={{ __html: field.label }}></span>}
      />
    </FormControl>
  );
};
